import {makeAutoObservable, observable} from 'mobx'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {KeyReq, KeyResp, RecoveryReq, RecoveryResp} from 'yougile-model'
import {Backend} from '@common/backend'
import {MessageBox} from '@components/message-box'
import {createUseStore} from '@containers/hooks'
import {PageService} from '@extensions/page-service'

interface State {
  error: boolean

  password: string
  password2: string
  wait: boolean
  recoveryError: string
}

export class RecoveryStore {
  state: State

  constructor() {
    PageService.getPage
    this.state = {
      error: false,
      password: '',
      password2: '',
      wait: false,
      recoveryError: ''
    }

    makeAutoObservable(
      this,
      {
        state: observable.shallow
      },
      {autoBind: true}
    )

    const key = this.getKey()
    if (!key || !Util.isIdOrUUID(key)) {
      this.state.error = true
      return
    }
    const email = PageService.getSearchParam('email')
    if (!email || !Util.isEmail(email)) {
      this.state.error = true
    }
  }

  submit(): void {
    if (this.state.wait) {
      return
    }
    if (!this.state.password) {
      this.state.recoveryError = Lang.msg.recoveryPassEmpty
      return
    }
    if (this.state.password.length < 3) {
      this.state.recoveryError = Lang.msg.recoveryPassShort
      return
    }
    if (this.state.password !== this.state.password2) {
      this.state.recoveryError = Lang.msg.recoveryPassNoMatch
      return
    }
    this.state.wait = true

    const key = this.getKey()
    const email = PageService.getSearchParam('email')
    if (!email) {
      return
    }
    const req: RecoveryReq = {
      email,
      key,
      password: this.state.password
    }

    Backend.postJSON<RecoveryResp>('/data/recover', req)
      .then(json => {
        const keyReq: KeyReq = {
          userId: json.userId,
          password: this.state.password
        }
        return Backend.postJSON<KeyResp>('/data/key', keyReq)
      })
      .then(res => {
        Backend.saveCredentials(res.userId, res.key)
        location.href = '/team/'
      })
      .catch(() => {
        this.state.wait = false
        MessageBox.show(Lang.msg.recoveryError, 'danger')
      })
  }

  keyDown(e: React.KeyboardEvent): void {
    this.state.recoveryError = ''
    if (e.keyCode === 13) {
      this.submit()
    }
  }

  private getKey(): string {
    return PageService.getPath().split('/recovery/')[1].split('/')[0]
  }

  setPassword(text: string): void {
    this.state.password = text
  }

  setPassword2(text: string): void {
    this.state.password2 = text
  }
}

export const [RecoveryContext, useRecoveryStore] = createUseStore(RecoveryStore)
